import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { findWidgetForGridSlot } from '../dashboard-layouts.utils';
import layoutStyles from '../utils/dashboard-layouts.styles';

const useStyles = makeStyles({
  ...layoutStyles
});

const LayoutN = props => {
  const classes = useStyles();

  const calculateWidgetForSlot = useCallback(slot => findWidgetForGridSlot({ ...props, slot }), [
    props
  ]);

  return (
      
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="stretch"
        xs={12}
        spacing={1}
      >
        <Grid item xs={12} md={8} className={classes.layoutMStyle} >
          {calculateWidgetForSlot(0)}
        </Grid>
        <Grid item xs={12} md={4} className={classes.layoutMStyle} >
          {calculateWidgetForSlot(1)}
        </Grid>
        <Grid item xs={12} md={8} className={classes.layoutMStyle}>
          {calculateWidgetForSlot(2)}
        </Grid>
        <Grid item xs={12} md={4} className={classes.layoutMStyle}>
          {calculateWidgetForSlot(3)}
        </Grid>
      </Grid>
  );
};


export default LayoutN;
